import axiosInstance from './axiosInstance';
import { 
  Payroll, 
  PayrollDetail, 
  ProcessPayrollRequest, 
  PostPayrollRequest, 
  BankFileExportData,
  PayrollReportDto 
} from '../types/payrolls.types';

const API_URL = '/Payrolls';

const payrollsService = {
  getAll: async (type?: 'Management' | 'Branch'): Promise<Payroll[]> => {
    const response = await axiosInstance.get(API_URL, {
      params: type ? { type } : undefined
    });
    return response.data;
  },

  getById: async (id: number): Promise<Payroll> => {
    const response = await axiosInstance.get(`${API_URL}/${id}`);
    return response.data;
  },

  getDetails: async (payrollId: number): Promise<PayrollDetail[]> => {
    const response = await axiosInstance.get(`${API_URL}/${payrollId}/details`);
    return response.data;
  },

  process: async (request: ProcessPayrollRequest): Promise<Payroll> => {
    const response = await axiosInstance.post(`${API_URL}/process`, request);
    return response.data;
  },

  post: async (request: PostPayrollRequest): Promise<Payroll> => {
    const response = await axiosInstance.post(`${API_URL}/post`, request);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`${API_URL}/${id}`);
  },

  exportBankFile: async (payrollId: number): Promise<BankFileExportData> => {
    const response = await axiosInstance.get(`${API_URL}/${payrollId}/export-bank-file`);
    return response.data;
  },

  getReport: async (payrollId: number): Promise<PayrollReportDto> => {
    const response = await axiosInstance.get(`${API_URL}/${payrollId}/report`);
    return response.data;
  },

  createConsolidatedJournal: async (month: number, year: number, branchIds?: number[]): Promise<{ message: string; journalEntryId: number }> => {
    const response = await axiosInstance.post(`${API_URL}/create-consolidated-journal`, {
      month,
      year,
      branchIds: branchIds && branchIds.length > 0 ? branchIds : undefined
    });
    return response.data;
  },

  deleteJournalEntry: async (month: number, year: number): Promise<void> => {
    await axiosInstance.delete(`${API_URL}/delete-journal`, {
      params: { month, year }
    });
  },
};

export default payrollsService;